module.exports = __webpack_public_path__ + "static/1.0_550x402_Glass_Heart_Desktop_1X-dcc2bc425ca3fe9a4c566d876b82383a.png";